import { GenericSvg } from '../../assets/svgs/GenericSVG';
import { MainButton } from '../../components/buttons/MainButton';
import { LoadingSpinner } from '../../components/loading/LoadingSpinner';
import { PageContainer, PageContentContainer } from '../../components/PageContainer';
import { InfoText } from '../../components/texts/InfoText';
import { colors } from '../../styles/colors';
import { useHandleVerifyEmail } from './utils/useHandleVerifyEmail';

export const PracticeUserEmailVerification = () => {
  const { emailVerificationStatus, startVerification } = useHandleVerifyEmail();

  const { title, subtitle, icon } = {
    IDLE: {
      title: 'E-Mail Verifizierung',
      subtitle: ['Klicke bitte hier um deine E-Mail Adresse für Physiofit zu bestätigen.'],
      icon: null,
    },
    PENDING: {
      title: 'E-Mail Verifizierung',
      subtitle: ['Verifizierung läuft... Bitte warte einen Moment.'],
      icon: <LoadingSpinner color={colors.primary} size={100} />,
    },
    SUCCESS: {
      title: 'E-Mail erfolgreich verifiziert',
      subtitle: [
        'Deine E-Mail-Adresse wurde erfolgreich verifiziert.',
        'Du kannst dieses Fenster jetzt schließen und zu Physiofit zurückkehren.',
      ],
      icon: <GenericSvg name="Checkmark" width={100} height={100} primaryColor={colors.success} />,
    },
    INVALID_URL: {
      title: 'E-Mail Verifizierung fehlgeschlagen',
      subtitle: [
        'Wir konnten deine E-Mail-Adresse nicht verifizieren. Der Verifizierungslink ist möglicherweise ungültig oder abgelaufen.',
      ],
      icon: <GenericSvg name="Close" width={100} height={100} primaryColor={colors.lightRed} />,
    },
  }[emailVerificationStatus];

  return (
    <PageContainer>
      <PageContentContainer>
        <InfoText headline={title} text={subtitle} />
      </PageContentContainer>
      {icon}
      {emailVerificationStatus === 'IDLE' && (
        <MainButton text="E-Mail-Adresse bestätigen" onClick={startVerification} />
      )}
    </PageContainer>
  );
};
